// ── Logique de groupement des exemplaires ────────────────────────────────────
// Deux BDs sont le "même album" si elles partagent série + numéro
// (ou titre seul si pas de série+numéro)
// Chaque groupe = un album logique, avec 1..N exemplaires physiques

export const groupKey = (bd) => {
  if (bd.serie && bd.numero) return `${bd.serie.trim().toLowerCase()}::${String(bd.numero).trim()}`;
  if (bd.serie) return `serie::${bd.serie.trim().toLowerCase()}::${bd.titre?.trim().toLowerCase()||''}`;
  return `titre::${bd.titre?.trim().toLowerCase()||bd.id}`;
};

// Retourne un tableau de groupes [{key, bds: [bd,...], ref: bd}]
export const groupBDs = (bds) => {
  const map = new Map();
  bds.forEach(bd => {
    const k = groupKey(bd);
    if (!map.has(k)) map.set(k, []);
    map.get(k).push(bd);
  });
  return Array.from(map.entries()).map(([key, list]) => ({
    key,
    bds: list,
    ref: list[0], // Premier comme référence pour affichage
  }));
};

// Pour la vue série : nombre de numéros UNIQUES (pas d'exemplaires)
export const countUniqueNums = (bds) => {
  const nums = new Set(bds.map(b => String(b.numero||'').trim()).filter(Boolean));
  // Si aucun n'a de numéro, compter les titres uniques
  if (nums.size === 0) {
    const titres = new Set(bds.map(b => (b.titre||'').trim().toLowerCase()).filter(Boolean));
    return titres.size || bds.length;
  }
  return nums.size;
};
